import { getProfileDetails, targetGateway, updateBranch } from '../../constants/apiRequest/requestConstants/endpoints';
import { makeRequest } from '../../helpers/makeApiRequest';

const defaultProfileResponse = {
  title: '',
  first_name: '',
  last_name: '',
  date_of_birth: '',
  phone: '',
  address: {},
  policies: [],
  isDefaultResponse: true
};

export const getUserProfile = async () => {
  const response = await makeRequest({
    method: 'GET',
    url: `${targetGateway()}${getProfileDetails}`
  });
  return response?.error ? defaultProfileResponse : response;
};

export const updateUserProfileBranch = async (updatedBranch) => {
  const quoteRequest = makeRequest({
    method: 'PUT',
    url: `${updateBranch}`,
    payload: {
      id: updatedBranch.branchName.id,
      branch_name: updatedBranch.branchName.value
    }
  });

  return await quoteRequest;
};

export const getBranchData = async (requestUrl) => {
  return await makeRequest({
    method: 'GET',
    url: requestUrl
  });
};
